import * as React from "react";
import * as ReactDOM from "react-dom";
import "./en-US";
import "./zh-CN";
import App from "./App";
import "./index.css";

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
